import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Breadcrumb from '../../../Components/Breadcrumbs'
import { AppBar, Box, Divider, Grid, Tab, Tabs, Typography } from '@material-ui/core'
import { useStyles } from './style'
import { Link, useHistory } from 'react-router-dom'
import _ from 'lodash'
import { CREATEYOURFIRSTAPPCLIENT, HOWTOGENERATEACCESSTOKEN, SAMPLEREQUESTANDRESPONSE } from './constant'
import activate from '../../../Assets/Images/activate.svg'
import key from '../../../Assets/Images/key.svg'
import biarrow from '../../../Assets/Images/biarrow.svg'
import { useScrollSpy } from '../../../Components/CustomHooks'
import step1 from '../../../Assets/Images/apireference/step1.png'
import step2 from '../../../Assets/Images/apireference/step2.png'
import step3 from '../../../Assets/Images/apireference/step3.png'
import getPublicApiConfig from '../../../Config/publicApiEnv'

const items = [
  { hash: CREATEYOURFIRSTAPPCLIENT },
  { hash: HOWTOGENERATEACCESSTOKEN },
  { hash: SAMPLEREQUESTANDRESPONSE }
]

const response = `{
  "meta": {
      "serverTimeStamp": "2022-05-04T09:23:00.215+00:00"
  },
  "data": {
      "total_count": 2,
      "programs": [
          {
              "description": "Test Description",
              "name": "Demo Program",
              "program_status": "approved",
              "program_id": "TestProgram",
              "state": "AZ",
              "utility_name": "Demo Utility",
              "incentive_structure": {
                  "UPFRONT_DISCOUNT": "$120.23"
              }
          },
          {
              "name": "Demo Program 2",
              "program_status": "approved",
              "program_id": "DEMO2",
              "state": "AZ",
              "utility_name": "Demo Utility",
              "incentive_structure": {
                  "UPFRONT_DISCOUNT": "13"
              }
          }
      ]
  },
  "error": {}
}`

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  }
}

function GettingStarted() {
  const classes = useStyles()
  const [active, setActive] = useState(window.location.hash.replace('#', ''))
  const [tabValue, setTabValue] = useState(0)
  const [sampleTabValue, setSampleTabValue] = useState(0)
  const activeSection = useScrollSpy({ items })
  const history = useHistory()
  const url = getPublicApiConfig(process.env.NODE_ENV) && getPublicApiConfig(process.env.NODE_ENV).api

  const selectSection = (id) => {
    if (document.getElementById(id)) {
      document.getElementById(id).scrollIntoView({ behavior: "smooth" })
    }
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
  }

  const handleSampleTabChange = (event, newValue) => {
    setSampleTabValue(newValue)
  }

  const getSampleResponse = () => (
    <Box>{`HTTP/1.1 200 OK 
    Content-Type: application/json; charset=utf-8 
    Status: 200 
    {
      "access_token": "eyJraWQiOiJDOVVLejV.......................wKJgyj298tV1_yjm5OckEfb4YqA",
      "expires_in": 3600,
      "token_type": "Bearer" 
    } 
    `}</Box>
  )

  const getSampleProgramResponse = () => (
    <Box whiteSpace="pre">
      {response}
    </Box>
  )

  useEffect(() => {
    if (activeSection) {
      setActive(activeSection)
    }
  }, [activeSection])

  useEffect(() => {
    if (active) {
      selectSection(active)
    }
  }, [])

  return (
    <>
      <Breadcrumb value={[{ 'Developer Hub': '/developer' }, { 'Getting Started': '/developer/getting-started' }]} />
      <Box className={classes.headerWrapper}>
        <Typography className={classes.title}>Getting Started</Typography>
        <Box className={classes.subTitle}>All the guides and references you need to get started.</Box>
      </Box>
      <Box className={classes.cardWrapper}>
        <Grid container spacing={4}>
          <Grid item xs={10}>
            <Box className={classes.cardContent} id='scrollspy'>
              <Typography className={classes.cardTitle}>VPP API</Typography>
              <Box className={classes.cardDescription}>
                This page is an easy step-by-step guide that shows how to use the Enphase VPP API. The guide has details on how to create an app client, access the client credentials, create tokens and make API requests              </Box>
              <Box className={classes.subCard} id={CREATEYOURFIRSTAPPCLIENT}>
                <Box display="flex" alignItems="center" px={2} pt={3} pb={2}>
                  <img src={activate} className={classes.subCardImg} alt="" />
                  <Box className={classes.subCardTitle} mx={1}>
                    Create your first APP Client
                  </Box>
                </Box>
                <Box mb={1}>
                  <Divider style={{ color: '#E1E1E1' }} />
                </Box>
                <Box className={classes.subCardContent}>
                  <ol>
                    <li className={classes.listItem}>Go to <Box className={classes.link} onClick={() => { history.push('/developer/api-credentials') }} component="span">Api Credentials</Box></li>
                    <img src={step1} alt="Go to Api Credentials Image" width="100%" />
                    <li className={classes.listItem}>Click on CREATE NEW APP CLIENT button</li>
                    <img src={step2} alt="" width="100%" />
                    <li className={classes.listItem}>Enter the new app client name and click submit. App Client will get created</li>
                    <img src={step3} alt="" width="100%" />
                  </ol>
                </Box>
              </Box>
              <Box className={classes.subCard} id={HOWTOGENERATEACCESSTOKEN}>
                <Box display="flex" alignItems="center" px={2} pt={3} pb={2}>
                  <img src={key} className={classes.subCardImg} alt="" />
                  <Box className={classes.subCardTitle} mx={1}>
                    How to generate access token
                  </Box>
                </Box>
                <Box mb={1}>
                  <Divider style={{ color: '#E1E1E1' }} />
                </Box>
                <Box className={classes.subCardContent} style={{ paddingBottom: '4px' }}>
                  {`To generate an access token, a post request must be sent to ${url}/auth/oauth2/token with the following parameters`}
                </Box>
                <ul>
                  <li>
                    <Box className={`${classes.subCardContent} ${classes.subCardList}`}>
                      <b>URL:</b> {`${url}/auth/oauth2/token?grant_type=client_credentials
                  `}
                    </Box>
                  </li>
                  <li>
                    <Box className={`${classes.subCardContent} ${classes.subCardList}`}>
                      <b>Headers:</b>
                      <ol>
                        <li><b>Authorization:</b> The client id and client secret of the app client must be sent as basic authorization header in base64encoded("client_id:client_secret"). For example, if your client_id is "abcd" and client_secret is "uvwxyz", then base64_encoded(“abcd:uvwxyz”) is 'YWJjZDp1dnd4eXo=' and the value for basic authorization header is 'Basic YWJjZDp1dnd4eXo='.</li>
                        <li><b>Content-Type:</b> The Content-Type header needs to be 'application/x-www-form-urlencoded'.</li>
                        <li><b>Accept:</b> The Accept header needs to be 'application/json'</li>
                      </ol>
                    </Box>
                  </li>
                </ul>
                <Box className={classes.subCardContent}>
                  An access_token will be generated and the user can start making API requests using the access_token and API key of the application. For more details, please refer to the sample request and response given below.
                </Box>
                <Box className={classes.subCardContent}>
                  <AppBar position="static" color="default">
                    <Tabs
                      value={tabValue}
                      onChange={handleTabChange}
                      indicatorColor="primary"
                      textColor="primary"
                      variant="scrollable"
                      scrollButtons="auto"
                      aria-label="scrollable auto tabs example"
                    >
                      <Tab label="CURL" {...a11yProps(0)} />
                      <Tab label="Php CURL" {...a11yProps(1)} />
                      <Tab label="Javascript XHR" {...a11yProps(2)} />
                    </Tabs>
                  </AppBar>
                  <TabPanel value={tabValue} index={0}>
                    <Box className={classes.tabHeading}>Sample Request</Box>
                    <Box className={classes.codeSnippet}>
                      {`curl --location --request POST '${url}/auth/oauth2/token?grant_type=client_credentials' \
                      --header 'Authorization: Basic NmM2b3RjYWtrMjM4bHBlOXVsZHRnY2VuOXE6MTFwbmVzMGZjcG0wdnRrNHU4azMycm1ldGpjYnY4cWZlaHJzNGhqMXJlcGdqZ2tpb3NoMA==' \
                      --header 'Content-Type: application/x-www-form-urlencoded' \
                      --header 'Accept: application/json' \
                      `}
                    </Box>
                    <Box className={classes.tabHeading}>Sample Response</Box>
                    <Box className={classes.codeSnippet}>{getSampleResponse()}</Box>
                  </TabPanel>
                  <TabPanel value={tabValue} index={1}>
                    <Box className={classes.tabHeading}>Sample Request</Box>
                    <Box className={classes.codeSnippet}>
                      {`<?php
 
                      $curl = curl_init();
                       
                      curl_setopt_array($curl, array(
                        CURLOPT_URL => '${url}/auth/oauth2/token?grant_type=client_credentials',
                        CURLOPT_RETURNTRANSFER => true,
                        CURLOPT_ENCODING => '',
                        CURLOPT_MAXREDIRS => 10,
                        CURLOPT_TIMEOUT => 0,
                        CURLOPT_FOLLOWLOCATION => true,
                        CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
                        CURLOPT_CUSTOMREQUEST => 'POST',
                        CURLOPT_HTTPHEADER => array(
                          'Authorization: Basic NmM2b3RjYWtrMjM4bHBlOXVsZHRnY2VuOXE6MTFwbmVzMGZjcG0wdnRrNHU4azMycm1ldGpjYnY4cWZlaHJzNGhqMXJlcGdqZ2tpb3NoMA==',
                          'Content-Type: application/x-www-form-urlencoded'
                          'Accept: application/json'
                        ),
                      ));
                       
                      $response = curl_exec($curl);
                       
                      curl_close($curl);
                      echo $response;
                      `}
                    </Box>
                    <Box className={classes.tabHeading}>Sample Response</Box>
                    <Box className={classes.codeSnippet}>{getSampleResponse()}</Box>
                  </TabPanel>
                  <TabPanel value={tabValue} index={2}>
                    <Box className={classes.tabHeading}>Sample Request</Box>
                    <Box className={classes.codeSnippet}>
                      {`var data = "";
 
                      var xhr = new XMLHttpRequest();
                      xhr.withCredentials = true;
                       
                      xhr.addEventListener("readystatechange", function() {
                        if(this.readyState === 4) {
                          console.log(this.responseText);
                        }
                      });
                       
                      xhr.open("POST", "${url}/auth/oauth2/token?grant_type=client_credentials");
                      xhr.setRequestHeader("Authorization", "Basic NmM2b3RjYWtrMjM4bHBlOXVsZHRnY2VuOXE6MTFwbmVzMGZjcG0wdnRrNHU4azMycm1ldGpjYnY4cWZlaHJzNGhqMXJlcGdqZ2tpb3NoMA==");
                      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                      xhr.setRequestHeader("Accept", "application/json");
                      
                      xhr.send(data);
                      `}
                    </Box>
                    <Box className={classes.tabHeading}>Sample Response</Box>
                    <Box className={classes.codeSnippet}>{getSampleResponse()}</Box>
                  </TabPanel>
                </Box>
              </Box>
              <Box className={classes.subCard} id={SAMPLEREQUESTANDRESPONSE}>
                <Box display="flex" alignItems="center" px={2} pt={3} pb={2}>
                  <img src={biarrow} className={classes.subCardImg} alt="" />
                  <Box className={classes.subCardTitle} mx={1}>
                    Sample Request and Response
                  </Box>
                </Box>
                <Box mb={1}>
                  <Divider style={{ color: '#E1E1E1' }} />
                </Box>
                <Box className={classes.subCardContent}>
                  <Box>Each API request must include an access token and API key and the request must be made to {url}</Box>
                  <Box>For example, if all the programs in an account are to be fetched, the request must be structured as below</Box>
                </Box>
                <Box className={`${classes.subCardContent} ${classes.subCardList}`}>
                  <ul>
                    <li><b>URL: </b>{`${url}/api/v1/programs`}</li>
                    <li>
                      <b>Headers: </b><br />
                      <ol type="a">
                        <li><b>Authorization: </b>access_token; For example, authorization header will be 'eyJra.......…….....wKYqA' where eyJra…...….......wKYqA is the generated access token</li>
                        <li><b>x-api-key: </b>Account-level API key; For example, x-api-key header will be 'uH6z………….……dgD9' where uH6z….……………dgD9 is the x-api-key of the account</li>
                      </ol>
                    </li>
                  </ul>
                </Box>
                <Box className={classes.subCardContent} style={{ padding: '0 20px' }}>Each response will have the following structure:</Box>
                <Box className={`${classes.subCardContent} ${classes.subCardList}`}>
                  <ul>
                    <li><b>meta: </b>Contains serverTimeStamp to indicate the current time.</li>
                    <li><b>data: </b>Contains response data in case of 200 OK status code. The structure of data response is specified in the Cloud API document</li>
                    <li><b>error: </b>
                      <ul style={{ listStyleType: 'circle' }}>
                        <li>Contains code to indicate error code in case of 4xx status code</li>
                        <li>Contains displayMessage to indicate error message</li>
                        <li>Contains additionalInfo to indicate more details on the error. This is an optional field</li>
                        <li>Contains errorRefNo to indicate reference number for the error; Unique trace id generated randomly</li>
                      </ul>
                    </li>
                  </ul>
                </Box>
                <Box className={classes.subCardContent} style={{ padding: '0 20px' }}>For example, if API response is received in apiResponse variable then</Box>
                <Box className={`${classes.subCardContent} ${classes.subCardList}`}>
                  <ul>
                    <li>apiResponse.getData() will give the required data response for 200 ok status</li>
                    <li>apiResponse.getError() will give the required details of error for 4xx status</li>
                  </ul>
                </Box>
                <Box className={classes.subCardContent} style={{ padding: '0 20px' }}>For more details, refer to the below sample request and response</Box>
                <Box className={classes.subCardContent}>
                  <AppBar position="static" color="default">
                    <Tabs
                      value={sampleTabValue}
                      onChange={handleSampleTabChange}
                      indicatorColor="primary"
                      textColor="primary"
                      variant="scrollable"
                      scrollButtons="auto"
                      aria-label="scrollable auto tabs example"
                    >
                      <Tab label="CURL" {...a11yProps(0)} />
                      <Tab label="Php CURL" {...a11yProps(1)} />
                      <Tab label="Javascript XHR" {...a11yProps(2)} />
                    </Tabs>
                  </AppBar>
                  <TabPanel value={sampleTabValue} index={0}>
                    <Box className={classes.tabHeading}>Sample Request</Box>
                    <Box className={classes.codeSnippet}>
                      {`curl --location --request GET '${url}/api/v1/programs' \
                        --header 'Authorization: eyJraWQiOiJDOVVLejV.......................wKJgyj298tV1_yjm5OckEfb4YqA' \
                        --header 'x-api-key: uH6zRkYXS12Xc5d7mIr4x8SiKZ52zYxDc2ljdgD9' \
                      `}
                    </Box>
                    <Box className={classes.tabHeading}>Sample Response</Box>
                    <Box className={classes.codeSnippet}>{getSampleProgramResponse()}</Box>
                  </TabPanel>
                  <TabPanel value={sampleTabValue} index={1}>
                    <Box className={classes.tabHeading}>Sample Request</Box>
                    <Box className={classes.codeSnippet}>
                      {`<?php
                        $curl = curl_init();
                        curl_setopt_array($curl, array(
                          CURLOPT_URL => '${url}/api/v1/programs',
                          CURLOPT_RETURNTRANSFER => true,
                          CURLOPT_ENCODING => '',
                          CURLOPT_MAXREDIRS => 10,
                          CURLOPT_TIMEOUT => 0,
                          CURLOPT_FOLLOWLOCATION => true,
                          CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
                          CURLOPT_CUSTOMREQUEST => 'GET',
                          CURLOPT_HTTPHEADER => array(
                            'Authorization: eyJraWQiOiJDOVVLejV.......................wKJgyj298tV1_yjm5OckEfb4YqA',
                            'x-api-key: uH6zRkYXS12Xc5d7mIr4x8SiKZ52zYxDc2ljdgD9'
                          ),
                        ));
                        $response = curl_exec($curl);
                        curl_close($curl);
                        echo $response;
                      `}
                    </Box>
                    <Box className={classes.tabHeading}>Sample Response</Box>
                    <Box className={classes.codeSnippet}>{getSampleProgramResponse()}</Box>
                  </TabPanel>
                  <TabPanel value={sampleTabValue} index={2}>
                    <Box className={classes.tabHeading}>Sample Request</Box>
                    <Box className={classes.codeSnippet}>
                      {`var xhr = new XMLHttpRequest();
                        xhr.withCredentials = true;
                        xhr.addEventListener("readystatechange", function() {
                          if(this.readyState === 4) {
                            console.log(this.responseText);
                          }
                        });
                         
                        xhr.open("GET", "${url}/api/v1/programs");
                        xhr.setRequestHeader("Authorization", "eyJraWQiOiJDOVVLejV.......................wKJgyj298tV1_yjm5OckEfb4YqA");
                        xhr.setRequestHeader("x-api-key", "uH6zRkYXS12Xc5d7mIr4x8SiKZ52zYxDc2ljdgD9");
                         
                        xhr.send();
                      `}
                    </Box>
                    <Box className={classes.tabHeading}>Sample Response</Box>
                    <Box className={classes.codeSnippet}>{getSampleProgramResponse()}</Box>
                  </TabPanel>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box className={classes.scrollSpyContainer}>
              <>
                <Box className={classes.scrollSpyListText} pb={0.5}><b>On this page</b></Box>
                <Box id={CREATEYOURFIRSTAPPCLIENT} py={1} pl={0.5} onClick={() => { setActive(CREATEYOURFIRSTAPPCLIENT); selectSection(CREATEYOURFIRSTAPPCLIENT) }} className={`${active === CREATEYOURFIRSTAPPCLIENT ? classes.currentSection : ''}`}><Link className={classes.scrollSpyListText} to={{ pathname: '/developer/getting-started', hash: `#${CREATEYOURFIRSTAPPCLIENT}` }} replace>Create your first APP Client</Link></Box>
                <Box id={HOWTOGENERATEACCESSTOKEN} py={1} pl={0.5} onClick={() => { setActive(HOWTOGENERATEACCESSTOKEN); selectSection(HOWTOGENERATEACCESSTOKEN) }} className={`${active === HOWTOGENERATEACCESSTOKEN ? classes.currentSection : ''}`}><Link className={classes.scrollSpyListText} to={{ pathname: '/developer/getting-started', hash: `#${HOWTOGENERATEACCESSTOKEN}` }} replace>How to generate Access Token</Link></Box>
                <Box id={SAMPLEREQUESTANDRESPONSE} py={1} pl={0.5} onClick={() => { setActive(SAMPLEREQUESTANDRESPONSE); selectSection(SAMPLEREQUESTANDRESPONSE) }} className={`${active === SAMPLEREQUESTANDRESPONSE ? classes.currentSection : ''}`}><Link className={classes.scrollSpyListText} to={{ pathname: '/developer/getting-started', hash: `#${SAMPLEREQUESTANDRESPONSE}` }} replace>Sample Request and Response</Link></Box>
              </>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default GettingStarted
